"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var navMenu_1 = __importDefault(require("./navMenu"));
var creatorPage_1 = __importDefault(require("./creatorPage"));
var fanClubPage_1 = __importDefault(require("./fanClubPage"));
var starsPages_1 = __importDefault(require("./starsPages"));
var getStartedForm_1 = __importDefault(require("./getStartedForm"));
var collectiblePages_1 = __importDefault(require("./collectiblePages"));
var globals_1 = __importDefault(require("./globals"));
var homePage_1 = __importDefault(require("./homePage"));
// combine language objects
function combineObjects(dataArray) {
    var combinedObject = { en: { translations: {} }, es: { translations: {} } };
    dataArray.forEach(function (item) {
        // Merge English (en) objects
        Object.keys(item.en.translations).forEach(function (key) {
            combinedObject.en.translations[key] = item.en.translations[key];
        });
        // Merge Spanish (es) objects
        Object.keys(item.es.translations).forEach(function (key) {
            combinedObject.es.translations[key] = item.es.translations[key];
        });
    });
    return combinedObject;
}
var transConfigs = combineObjects(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], globals_1.default, true), navMenu_1.default, true), homePage_1.default, true), fanClubPage_1.default, true), creatorPage_1.default, true), starsPages_1.default, true), getStartedForm_1.default, true), collectiblePages_1.default, true));
//console.log(transConfigs)
exports.default = transConfigs;
